import React from 'react';
import HelmetImport from 'react-helmet';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Helmet: any = HelmetImport;
import { useIntl } from 'react-intl';

interface Props {
  id?: string;
  title?: string;
}

export const PageTitle: React.FC<Props> = ({ id, title }) => {
  const { formatMessage } = useIntl();

  return (
    <Helmet>
      {!!id && <title>{formatMessage({ id })}</title>}
      {!id && !!title && <title>{title}</title>}
    </Helmet>
  );
};
